import { container } from 'src/ioc/StaticContainer';

export * from './AppError';

// TODO: Should we expose an `ErrorService` for tracking errors generically?
export function trackError(error: Error, rest?: Record<string, unknown>) {
    container.getOptional('DatadogService')?.submitErrorToDatadog(error, rest);
}
